import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSpectrumComponent } from './simple-icons-spectrum.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSpectrumComponent ],
    exports:      [ SimpleIconsSpectrumComponent ],
    bootstrap:    []
})
export class SimpleIconsSpectrumModule {}
